import React from 'react';
import { X, AlertTriangle, DollarSign } from 'lucide-react';
import './Modal.css';

interface InsufficientBalanceModalProps {
  isOpen: boolean;
  onClose: () => void;
  currentBalance: number;
  requiredAmount: number;
  onAddFunds: () => void;
  onUpdatePaymentMethod: () => void;
  hasPaymentMethod: boolean;
}

const InsufficientBalanceModal: React.FC<InsufficientBalanceModalProps> = ({
  isOpen,
  onClose,
  currentBalance,
  requiredAmount,
  onAddFunds,
  onUpdatePaymentMethod,
  hasPaymentMethod
}) => {
  if (!isOpen) return null;

  const shortage = requiredAmount - currentBalance + 2; // Include minimum balance

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content insufficient-modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header error">
          <h2><AlertTriangle size={24} /> Insufficient Balance</h2>
          <button onClick={onClose} className="modal-close">
            <X size={20} />
          </button>
        </div>

        <div className="modal-body">
          <div className="balance-breakdown">
            <div className="balance-line">
              <span>Current Balance:</span>
              <span className={currentBalance < 0 ? 'negative' : ''}>
                ${currentBalance.toFixed(2)}
              </span>
            </div>
            <div className="balance-line">
              <span>Required for Operation:</span>
              <span>-${requiredAmount.toFixed(2)}</span>
            </div>
            <div className="balance-line">
              <span>Max Debt Allowed:</span>
              <span>-$10.00</span>
            </div>
            <div className="balance-line total">
              <span>Amount Needed:</span>
              <span className="negative">${shortage.toFixed(2)}</span>
            </div>
          </div>

          <div className="insufficient-info">
            <DollarSign size={20} />
            <p>Add at least ${shortage.toFixed(2)} to complete this operation.</p>
          </div>
        </div>

        <div className="modal-footer">
          <button onClick={onClose} className="btn-secondary">Cancel</button>
          {hasPaymentMethod ? (
            <button onClick={onAddFunds} className="btn-primary">Add Funds</button>
          ) : (
            <button onClick={onUpdatePaymentMethod} className="btn-primary">
              Add Payment Method
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default InsufficientBalanceModal;